import { Box, Chip } from '@mui/material';
import React from 'react';

export type MoNotificationBadgeProps = {
  children?: React.ReactNode;
};

export function MoNotificationBadge({ children }: MoNotificationBadgeProps) {
  if (!children) {
    return (
      <Box
        sx={{ width: '8px', height: '8px', borderRadius: '50%', backgroundColor: 'error.main' }}
      />
    );
  }

  return (
    <Chip
      size="small"
      label={children}
      sx={{
        height: '16px',
        backgroundColor: 'error.main',
        color: 'white',
        fontWeight: 'bold',
        fontSize: 11,
        '& span': {
          padding: '6px',
        },
      }}
    />
  );
}
